@use "../../sass/global/global" as *;

$border-color: #cdcdcd;
$background-color-trumpf: #005074;
$background-color-mytrumpf: #bbd03a;

.ux-iws-header {
    position: relative;
    display: block;
    z-index: 799;

    @media only screen and (min-width: $tablet) {
        overflow: visible;
    }

    &--locale-selection-open,
    &--active {
        height: 100vh;
        overflow-x: hidden;
        overflow-y: scroll;
        transform: translate(0, 0);

        @media only screen and (min-width: $desktop-s-navigation-100) {
            overflow: visible;
            height: auto;
        }
    }

    .ux-iws-header__main-wrapper {
        width: 100%;
        height: 100px;
        background: $color-white;
        border-bottom: 1px solid $border-color;
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            transform: none;
        }
    }

    &--empty .ux-iws-header__main-wrapper {
        height: 44px;
    }

    .ux-iws-header__logo {
        width: 70px;
        display: flex;
        align-self: center;
        justify-content: flex-start;
        z-index: 21;

        img {
            width: 100%;
            height: auto;
        }
    }

    .ux-iws-header__navigation-wrapper {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            left: auto;
            top: auto;
            width: calc(100% - 50px);
            height: 100px;
            padding-left: 50px;
            align-self: flex-end;
        }

        @media only screen and (min-width: $desktop-l) {
            width: calc(100% - 70px);
            padding-left: 70px;
        }

        .ux-iws-nav {
            border-bottom: 0;
        }
    }

    .ux-iws-header__breadcrumb-wrapper {
        padding: 10px 30px;
        display: none;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: block;
        }
    }

    .ux-iws-header__dropdown-container {
        left: 0;
        top: 0;
        width: 100%;
        position: absolute;
        display: none;
        background: $color-white;
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);

        @media only screen and (max-width: $desktop-s-navigation-100 - 1) {
            padding-bottom: 60px;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            box-shadow: none;
        }

        .ux-iws-header__meta-container-dropdown {
            margin: 0 30px;
            padding: 30px 0;
            border-top: 1px solid #979797;
        }

        /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
        .ux-iws-navigation-meta {
            flex-direction: column;

            @media only screen and (min-width: $tablet) {
                flex-direction: row;
                justify-content: center;
            }
        }

        .ux-iws-navigation-meta__sub-menu {
            display: none;

            &--active {
                display: flex;
            }
        }

        .ux-button__trumpf {
            justify-content: center;
            border: 1px solid $background-color-mytrumpf;
            border-top: 5px solid $background-color-mytrumpf;
            margin: 0 auto;

            @media only screen and (max-width: $tablet) {
                width: 100%;
            }

            &:hover {
                background: $background-color-mytrumpf;
            }

            ux-icon {
                margin-left: 10px;
                transform: translateY(0.5px);
            }
        }

        .ux-iws-navigation-meta__item {
            display: flex;
            margin-bottom: 30px;

            @media only screen and (max-width: $tablet - 2px) {
                margin-left: 0;
            }

            > a {
                display: flex;
                cursor: pointer;
            }

            &:last-child {
                width: 100%;
                margin-bottom: 0;
            }
        }

        /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */

        .ux-iws-navigation-meta__icon-box {
            margin-right: 10px;
            position: relative;
        }

        .ux-iws-navigation-meta__item__flex-break {
            width: 100%;
        }
    }

    &.ux-iws-header--mytrumpf .ux-iws-header__dropdown-container {
        .ux-button__trumpf {
            border: 1px solid $background-color-trumpf;
            border-top: 5px solid $background-color-trumpf;
        }

        .ux-button__trumpf:hover {
            background: $background-color-trumpf;
        }
    }

    .ux-iws-header__dropdown-container--active {
        display: block;

        @media only screen and (min-width: $tablet) {
            z-index: 1;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-header__meta-container-dropdown {
            display: none !important;
        }
    }

    /* stylelint-disable max-nesting-depth */
    &--100 {
        .ux-iws-header__logo {
            width: 160px;
            height: 80px;

            svg {
                margin-left: -5px;
            }

            @media only screen and (min-width: $tablet) {
                width: 220px;

                svg {
                    margin-left: -10px;
                }
            }

            @media only screen and (min-width: $desktop-s-navigation-100) {
                width: 275px;
            }
        }

        .ux-iws-header__navigation-wrapper {
            @media only screen and (min-width: $desktop-s-navigation-100) {
                padding-left: 25px;
            }

            @media only screen and (min-width: $desktop-l) {
                padding-left: 50px;
            }
        }
    }
    /* stylelint-enable max-nesting-depth */
}

.ux-iws-nav-active--lvl-1,
.ux-iws-nav-active--lvl-2,
.ux-iws-nav-active--lvl-3,
.ux-iws-nav-active--lvl-4,
.ux-iws-nav-active--locale-selection {
    width: 100%;
    overflow-y: scroll;
    position: fixed;

    .ux-iws-nav-blur-page {
        background: $color-white;
        filter: blur(4px);
        pointer-events: none;

        * {
            pointer-events: none !important;
        }
    }
}
